// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalInventoryLogs_root__2frzD","log":"ModalInventoryLogs_log__2N5mn","date":"ModalInventoryLogs_date__2bDeK","userName":"ModalInventoryLogs_userName__1Kg7w"};